/*istanbul ignore next*/'use strict';

var Directive = require('../directive');

module.exports = new Directive({
  level: Directive.LP,
  final: true
});


// WEBPACK FOOTER //
// ./~/mokit/lib/template/directives/prevent.js